import axios from "functions/axios";

export const ListFacultyGroupsAPI = ({
  page = 1,
  page_size = 15,
  search = "",
  filters = {},
} = {}) =>
  axios
    .get("education/admin/faculty_groups/list_create/", {
      params: {
        page,
        page_size,
        search,
        ...filters,
      },
    })
    .then((res) => res.data);

export const CreateFacultyGroupAPI = (payload) =>
  axios.post("education/admin/faculty_groups/list_create/", payload).then((res) => res.data);

export const UpdateFacultyGroupAPI = ({ pk, data }) =>
  axios.put(`education/admin/faculty_groups/update_delete/${pk}/`, data).then((res) => res.data);

export const DeleteFacultyGroupAPI = (pk) =>
  axios.delete(`education/admin/faculty_groups/update_delete/${pk}/`).then((res) => res.data);
